import { Center, Spinner } from '@chakra-ui/react';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';

import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import BrokerAccountListLoadedContainer from 'presentation/containers/modules/brokerAccount/list/BrokerAccountListLoadedContainer';
import SettingsLayout from 'presentation/layout/modules/settings/SettingsLayout';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';

const BrokerAccountListPage: FC = () => {
  const { data, isFetching, error, refetch } = useFetchProfileQuery();

  const { t } = useTranslation();

  let isWrappedByCard = true;
  let content;
  if (isFetching) {
    content = (
      <Center>
        <Spinner />
      </Center>
    );
  } else if (data) {
    content = <BrokerAccountListLoadedContainer items={data.brokerAccounts} />;
    isWrappedByCard = false;
  } else if (error) {
    content = (
      <Center>
        <ErrorContainer
          error={error}
          onRetry={() => {
            refetch();
          }}
        />
      </Center>
    );
  } else {
    content = (
      <Center>
        <Spinner />
      </Center>
    );
  }

  if (isWrappedByCard) {
    content = (
      <AppCard w="100%" p="40px">
        {content}
      </AppCard>
    );
  }

  return (
    <SettingsLayout>
      <Helmet>
        <title>{t('navAccounts')}</title>
      </Helmet>
      <GridHeading>{t('pageTitleAccounts')}</GridHeading>
      {content}
    </SettingsLayout>
  );
};

export default BrokerAccountListPage;
